(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-v2"] && !Shopify.designMode) return;
  try {
    
  const bestsellerTabBtns = document.querySelectorAll('[data-bestseller-tab-open]');
  bestsellerTabBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const tabWrapper = e.target.closest('.best-sellers-tabs');
      const childBtns = tabWrapper.querySelectorAll('[data-bestseller-tab-open]');
      childBtns.forEach((childBtn) => {
        const id = childBtn.dataset.block;
        if(childBtn.dataset.block == e.target.dataset.block) {
          childBtn.setAttribute('aria-expanded', 'true');
          document.querySelector(id).classList.remove('hide');
        } else {
          childBtn.setAttribute('aria-expanded', 'false');
          document.querySelector(id).classList.add('hide');
        }
      });
    });
  });
  const bestsellerFitLinks = document.querySelectorAll('[data-section-type="best-sellers"] .product-thumbnail-fit-wrapper a');
  bestsellerFitLinks.forEach((bestsellerFitLink) => {
    if(localStorage.getItem('tesbros_customer_model')) bestsellerFitLink.classList.add('hide');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  const bestsellerTabBtns = document.querySelectorAll('[data-bestseller-tab-open]');
  bestsellerTabBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const tabWrapper = e.target.closest('.best-sellers-tabs');
      const childBtns = tabWrapper.querySelectorAll('[data-bestseller-tab-open]');
      childBtns.forEach((childBtn) => {
        const id = childBtn.dataset.block;
        if(childBtn.dataset.block == e.target.dataset.block) {
          childBtn.setAttribute('aria-expanded', 'true');
          childBtn.classList.add('is-hovered');
          document.querySelector(id).classList.remove('hide');
        } else {
          childBtn.setAttribute('aria-expanded', 'false');
          childBtn.classList.remove('is-hovered');
          document.querySelector(id).classList.add('hide');
        }
      });
    });
  });
  const bestsellerFitLinks = document.querySelectorAll('[data-section-type="best-sellers"] .product-thumbnail-fit-wrapper a');
  bestsellerFitLinks.forEach((bestsellerFitLink) => {
    if(localStorage.getItem('tesbros_customer_model')) bestsellerFitLink.classList.add('hide');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage-v2"] && !Shopify.designMode) return;
  try {
    
  const collageCTAs = document.querySelectorAll(`[data-collage-cta]`);
  collageCTAs.forEach((cta) => {
    cta.addEventListener('click', (e) => {
      const wrapper = e.target.closest('.collage-small-cta');
      if(wrapper.classList.contains('active'))
        wrapper.classList.remove('active');
      else
        wrapper.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
  const collageCTAs = document.querySelectorAll(`[data-collage-cta]`);
  collageCTAs.forEach((cta) => {
    cta.addEventListener('click', (e) => {
      const wrapper = e.target.closest('.collage-small-cta');
      if(wrapper.classList.contains('active'))
        wrapper.classList.remove('active');
      else
        wrapper.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-the-look"] && !Shopify.designMode) return;
  try {
    
  const hotspots = document.querySelectorAll('[data-hotspot]');
  const hotspotContents = document.querySelectorAll('[data-hotspot-content]');
  hotspots.forEach((spot) => {
    spot.addEventListener('mouseenter', (e) => {
      e.stopPropagation();
      e.target.classList.add('temp-active')
    });
    spot.addEventListener('mouseleave', (e) => {
      e.stopPropagation();
      if(e.toElement.classList && !(e.toElement.classList.contains('get-lookbook--title') || e.toElement.classList.contains('get-lookbook--content') || e.toElement.classList.contains('get-lookbook--text'))) {
        e.target.classList.remove('temp-active');
      } else {
        e.target.classList.add('temp-active');
      }
    });
    spot.addEventListener('click', (e) => {
      e.stopPropagation();
      hotspots.forEach((hotspot) => {
        if(hotspot != spot) {
          hotspot.classList.remove('active')
        }
      });
      e.target.classList.toggle('active')
    });
  });
  hotspotContents.forEach((content) => {
    content.addEventListener('mouseenter', (e) => {
      e.stopPropagation();
      e.target.previousElementSibling.classList.add('temp-active');
    });
    content.addEventListener('mouseleave', (e) => {
      e.stopPropagation();
      e.target.previousElementSibling.classList.remove('temp-active');
    });
  });
  window.addEventListener('click', (e) => {
    if(!(e.target.closest('.glide__arrow ') || e.target.classList.contains('glide__arrow '))) {
      hotspots.forEach((spot) => {
        spot.classList.remove('active');
        spot.classList.remove('temp-active')
      });
    }
  });

  const lookbookSlides = document.querySelectorAll('.get-lookbooks.glide');
  if(lookbookSlides.length > 0) {
    lookbookSlides.forEach((lookbookSlide) => {
      if(lookbookSlide.querySelector('.glide__slides')) {
        new Glide(lookbookSlide, {
          type: 'carousel',
          startAt: 0,
          perView: 1,
          gap: 0
        }).mount();
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-form"]) return;
  try {
    
  const passwordInput = document.querySelector('[name="customer[password]"]');
  const loginSubmitBtn = document.querySelector('#customer_login [type="submit"]');
  if(passwordInput && loginSubmitBtn) {
    localStorage.setItem("temp_customer_pass", passwordInput.value);
    passwordInput.addEventListener('keyup', (e) => {
      localStorage.setItem("temp_customer_pass", e.target.value);
    });
    loginSubmitBtn.addEventListener('click', (e) => {
      localStorage.setItem("temp_customer_pass", passwordInput.value);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
const lookbookProducts = document.querySelectorAll('.right-img-section.glide');
if (lookbookProducts.length > 0) {
  lookbookProducts.forEach((lookbookProduct) => {
    if (lookbookProduct.querySelector('.glide__slides')) {
      const glide = new Glide(lookbookProduct, {
        type: 'carousel',
        startAt: 0,
        drag: false,
        perTouch: 0,
        perView: 1,
        touchRatio: 0,
        dragThreshold: 1000,
        gap: 0,
        focusAt: 'center'
      }).mount();
      document.querySelectorAll('.main_dot').forEach(dot => {
        dot.addEventListener('click', () => {
          const targetIndex = parseInt(dot.getAttribute('data-target'), 10);
          glide.go(`=${targetIndex}`);
          document.querySelectorAll('.main_dot_wrapper').forEach(d => d.classList.remove('active_dot'));
          dot.parentElement.classList.add('active_dot');
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialsSlides = document.querySelectorAll('.testimonials---slider.glide');
  if(testimonialsSlides.length > 0) {
    testimonialsSlides.forEach((testimonialsSlide) => {
      if(testimonialsSlide.querySelector('.glide__slides')) {
        new Glide(testimonialsSlide, {
          type: 'carousel',
          startAt: 0,
          perView: 3.2,
          gap: 10,
          focusAt: 'center',
          breakpoints: {
            767: {
              gap: 10,
              focusAt: 'center',
              perView: 1.1,
              arrows:false
            }
          }
        }).mount();
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["registration-form"]) return;
  try {
    
  const passwordInput = document.querySelector('[name="customer[password]"]');
  const registerSubmitBtn = document.querySelector('#create_customer [type="submit"]');
  if(passwordInput && registerSubmitBtn) {
    localStorage.setItem("temp_customer_pass", passwordInput.value);
    passwordInput.addEventListener('keyup', (e) => {
      localStorage.setItem("temp_customer_pass", e.target.value);
    });
    registerSubmitBtn.addEventListener('click', (e) => {
      localStorage.setItem("temp_customer_pass", passwordInput.value);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-slideshow"] && !Shopify.designMode) return;
  try {
    
  const teamSlides = document.querySelectorAll('.team--slider.glide');
  if(teamSlides.length > 0) {
  teamSlides.forEach((teamSlide) => {
      if(teamSlide.querySelector('.glide__slides')) {
        new Glide(teamSlide, {
          type: 'carousel',
          startAt: 0,
          perView: 1,
          focusAt: 'center',
          gap: 0
        }).mount();
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-v2"] && !Shopify.designMode) return;
  try {
    
  const testimonialsSlides = document.querySelectorAll('.testimonials-v3--slider.glide');
  if(testimonialsSlides.length > 0) {
    testimonialsSlides.forEach((testimonialsSlide) => {
      if(testimonialsSlide.querySelector('.glide__slides')) {
        new Glide(testimonialsSlide, {
          type: 'carousel',
          startAt: 0,
          perView: 3,
          gap: 0,
          focusAt: 'center',
          breakpoints: {
            767: {
              gap: 10,
              focusAt: 'center',
              perView: 1.2,
              arrows:false
            }
          }
        }).mount();
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialsSlides = document.querySelectorAll('.testimonials-v2--slider.glide');
  if(testimonialsSlides.length > 0) {
    testimonialsSlides.forEach((testimonialsSlide) => {
      if(testimonialsSlide.querySelector('.glide__slides')) {
        new Glide(testimonialsSlide, {
          type: 'carousel',
          startAt: 0,
          perView: 1.5,
          focusAt: 'center',
          gap: 28,
          breakpoints: {
            767: {
              gap: 10,
              perView: 1.2
            }
          }
        }).mount();
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tabs"] && !Shopify.designMode) return;
  try {
    
class TesBrosVideoTabs extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
    this.labels = this.querySelectorAll('label');
    this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('click', this.onChange.bind(this)));

    this.breakpoint = window.matchMedia('(max-width:991px)');
    this.breakpoint.addListener(this.breakpointCheck.bind(this));
    this.breakpointCheck();
  }

  onChange(event) {
    this.labels.forEach(label => label.classList.remove('active'));
    const activeLabel = this.querySelector('label[for="'+event.target.id+'"]');
    const activeTabName = activeLabel.textContent;
    activeLabel.classList.add('active');
    const swiper = this.swipers.length > 0 ? this.swipers[event.target.value] : null;
    if(swiper) {
      swiper.update();
    }
  }

  breakpointCheck() {
    if (this.breakpoint && this.breakpoint.matches === true ) {
      // mobile
      if(this.swipers.length === 0) {
        const videoTabSlides = document.querySelectorAll('.video--slider.glide');
        if(videoTabSlides.length > 0) {
          videoTabSlides.forEach((videoTabSlide) => {
            if(videoTabSlide.querySelector('.glide__slides')) {
              var videoTabGlide = new Glide(videoTabSlide, {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                focusAt: 'center',
                gap: 0
              }).mount();
              this.swipers.push(videoTabGlide);
            }
          })
        }
      }

    } else if (this.breakpoint.matches === false) {
      // desktop
      if(this.swipers.length > 0) {
        this.swipers.forEach((swiper) => {
          swiper.destroy();
        });
        this.swipers = [];
      }
    }
  }
}

customElements.define('video-tabs', TesBrosVideoTabs);

  } catch(e) { console.error(e); }
})();
})();
